import type { ButtonType } from '@epilot/journey-logic-commons'
import classNames from 'classnames'

import classes from './ChoiceButton.module.scss'

export const getWrapperClassName = (
  buttonType?: ButtonType,
  isMobile?: boolean
) => {
  return classNames(
    buttonType === 'stack' && classes.buttonWrapColumn,
    buttonType === 'chip' && classes.buttonWrapChips,
    buttonType === 'row' || !buttonType
      ? isMobile
        ? classes.buttonWrapColumn
        : classes.buttonWrapRow
      : ''
  )
}
